<script lang="ts">
	import translations from "./Address.translations.json";
	import Link from "./Link.svelte";
	import { getTranslate } from "../utils/getTranslate.js";

	const translate = getTranslate(translations);

	interface $$Props {
		class?: string;
		showHeadquarterState: boolean;
	}

	let addressClass = "";
	export { addressClass as class };

	$: ({ showHeadquarterState = true } = $$props as $$Props);
</script>

<Link
	class="group text-white decoration-transparent hover:decoration-white {addressClass}"
	href={translate("headquartersGoogleMapsLink")}
	target="_blank"
	rel="noopener noreferrer"
>
	<table>
		<tr>
			<td class="whitespace-nowrap font-normal">{translate("headquartersCompanyName")}</td>
		</tr>
		<tr>
			<td class="whitespace-nowrap font-normal">{translate("headquartersStreet")}</td>
		</tr>
		<tr>
			<td class="whitespace-nowrap font-normal">{translate("headquartersCity")}</td>
		</tr>
		{#if showHeadquarterState}
			<tr>
				<td>{translate("headquartersState")}</td>
			</tr>
		{/if}
	</table>
</Link>
